import { Link } from 'react-router-dom'
import styled from 'styled-components'

const LinkNoStyle = styled(Link)`
	text-decoration: none;
	color: inherit;
`

export default LinkNoStyle
